import { forwardRef } from 'react'

import { Textarea } from '../Textarea/index.js'

import { FormControlLayout } from './FormControlLayout.js'
import { FormControlTextareaProps } from './types.js'
import {
  extractLayoutProps,
  getFormControlErrorAriaProps,
  useFormControlIds,
} from './utils.js'

export const FormControlTextarea = forwardRef<
  HTMLTextAreaElement,
  FormControlTextareaProps
>((props, ref) => {
  const { layoutProps, inputProps } = extractLayoutProps(props)
  const ids = useFormControlIds()

  return (
    <FormControlLayout {...layoutProps} ids={ids}>
      <Textarea
        ref={ref}
        {...inputProps}
        {...getFormControlErrorAriaProps({ ...props, errorId: ids.errorId })}
      />
    </FormControlLayout>
  )
})
